export default {
    namespaced: true,
    state: {
        finenesses: [],
        supplierFinenesses: [],
        errors: {
            getFinenesses: ''
        }
    },
    getters: {
        getFinenessByMaterial: state => id => {
            if (!id) return state.finenesses
            return state.finenesses.filter(item => item.MaterialID == id)
        },
        getFinenessIdByName: state => (Value, MaterialID) => {
            if (!Value || !MaterialID || !state.finenesses.length) return ''
            let arr = state.finenesses.filter(
                item => item.Value == Value && item.MaterialID == MaterialID
            )
            return arr.length ? arr[0].FinenessID : ''
        },
        //options for supplier products page filter
        getSupplierFinenessesByMaterials: state => ids => {
            if (!ids.length) return state.supplierFinenesses
            const idsArr = ids.map(id => parseInt(id))
            return state.supplierFinenesses.filter(
                item => idsArr.indexOf(parseInt(item.MaterialID)) !== -1
            )
        },
        //values for supplier products page filter, default all
        supplierFinenessesValuesArr(state) {
            return state.supplierFinenesses.map(fineness => fineness.FinenessID)
        },
        getSupplierFinenessesNamesArr: state => ids => {
            if (!ids.length) return []
            const idsArr = ids.map(id => parseInt(id))
            return state.supplierFinenesses
                .filter(
                    item => idsArr.indexOf(parseInt(item.FinenessID)) !== -1
                )
                .map(fineness => fineness.Value)
        }
    },
    mutations: {
        SET_FINENESSES(state, payload) {
            state.finenesses = payload
        },
        SET_SUPPLIER_FINENESSES(state, payload) {
            state.supplierFinenesses = payload
        },
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async getFineness({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'getFinenesses',
                val: ''
            })

            const url = '/public/dict/finenesses'

            try {
                const resp = await this.$axios
                    .get(url, {
                        params: data
                    })
                    .then(res => {
                        return res.data
                    })

                commit('SET_FINENESSES', resp)
                if (data && data.existing) {
                    commit('SET_SUPPLIER_FINENESSES', resp)
                } else {
                    commit('SET_FINENESSES', resp)
                }
            } catch (e) {
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getFinenesses',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getFinenesses',
                        val: 'Ошибка'
                    })
                }
            }
        }
    }
}
